import { useEffect, useState } from "react";

import getEnvVariables from "@/libs/shared/api/getEnvVariables";

/**
 * Public environment variables that are safe to expose to the client.
 *
 * IMPORTANT: Never add sensitive keys like:
 * - COMETCHAT_API_KEY (use server action getCometChatMessages)
 * - NUTRITION_API_KEY (use server action generateNutritionToken)
 */
export type EnvVariablesType = {
  // App URLs
  API_URL: string;
  APP_NAME: string;
  FRONTEND_URL: string;
  BUILDER_URL: string;
  NUTRITION_BUILDER_URL: string;
  NEW_BUILDER_URL: string;
  NEXT_PUBLIC_ENV: string;

  // Firebase (public by design)
  FIREBASE_PROJECT_ID: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;

  // CometChat (only public identifiers)
  COMETCHAT_APP_ID: string;
  COMETCHAT_REGION: string;
  COMETCHAT_WIDGET_ID: string;
  COMETCHAT_AUTH_KEY: string; // Required for widget init (CometChat design)

  // Payment providers (publishable keys only)
  STRIPE_PUBLISHABLE_KEY: string;
  PADDLE_API_KEY: string; // Client token, not API secret

  // Third party
  GOOGLE_MAPS_KEY: string;
  INTERCOM_APP_ID: string;
};

let envVariables: EnvVariablesType | undefined = undefined;

export default function useEnvVariables() {
  const [env, setEnv] = useState<EnvVariablesType | undefined>(envVariables);

  useEffect(() => {
    void (async () => {
      if (!env) {
        envVariables = await getEnvVariables();
        setEnv(envVariables);
      }
    })();
  }, [env]);

  return env;
}
